export default "__VITE_ASSET__M5Js4jOt__"